type AdminPanelCardProps = {
  title: string;
  description: string;
};

export function AdminPanelCard({ title, description }: AdminPanelCardProps) {
  return (
    <article className="rounded-2xl border border-grid-200 bg-white p-6 shadow-sm shadow-ink-900/5">
      <h2 className="text-lg font-semibold text-ink-900">{title}</h2>
      <p className="mt-2 text-sm text-ink-500">{description}</p>
    </article>
  );
}
